import React, { useEffect, useState, useMemo, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
// import '../assets/css/RDMupload.css';
import '../assets/css/gapsybdmupload.css';
import { demformdata, createTextFileApi, rafmapping, mqemocr, OcrWebsocket, OcrMethod, formdata } from "../components/ApiProperty";
import '../assets/css/Tableproperty.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import { Listoftablesearchbox1, UploadLoadingIcon } from "../components/Propertyfile";
import { allowmodifytemplate, Makerlist_deptwisetemplates } from '../components/ApiProperty';
import { TableTemplateListGapsy, ListofTableFontsize, PaginationComponentForm2 } from "../components/TableProperty";
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import formStyles from '../assets/css/gapsy-form.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import PopupTableModal from '../components/PopupTableModal'
import { useSession } from '../components/SessionContext';



const GapsyTablelist = () => {
    const [formData, setFormData] = useState({});
    const [popupData, setPopupData] = useState(null);
    const [popShowModal, setPopShowModal] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [popupCallback, setPopupCallback] = useState(null);
    const [formStructure, setFormStructure] = useState(null);
    const [rafData, setRafData] = useState([]);
    const [rafTableName, setRafTableName] = useState("");
    const [paramState, setParam] = useState('');
    // const [activeTab, setActiveTab] = useState('manual'); // 'manual' or 'ai'
    const [activeTab, setActiveTab] = useState('manual'); // 'manual' or 'ai'

    // Separate states for both tabs
    const [manualFormData, setManualFormData] = useState({});
    const [aiFormData, setAIFormData] = useState({});

    const [valueMode, setValueMode] = useState("raw");
    // "raw" | "static"
    const [wsLoading, setWsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [modalMessage, setModalMessage] = useState('');
    const [modalMessageOne, setModalMessageOne] = useState('');
    const [messageType, setMessageType] = useState(''); // 'error', 'success', or 'warning'
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [navigateOnClose, setNavigateOnClose] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false); // State to control notification modal visibility
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [uploadStatus, setUploadStatus] = useState('');
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [tableNames, setTableNames] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(7); // Set the number of records per page
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [file, setFile] = useState(null);
    const [errMsg, setErrMsg] = useState('');
    const [showNotifyModalAfterConfirmation, setShowNotifyModalAfterConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [notifyType, setNotifyType] = useState('EOD'); // Set EOD as default
    // const [selectedLayout, setSelectedLayout] = useState('');
    const [selectedLayout, setSelectedLayout] = useState('');
    const [dataType, setDataType] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false); // State to prevent form submission until notification selection
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [fromname, setFormName] = useState('');
    const fileInputRef = useRef(null);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const userRole = localStorage.getItem('userRole');
    const [sheetSelectionModal, setSheetSelectionModal] = useState({
        show: false,
        sheets: [],
        selectedSheets: [],
        workbook: null,
        file: null,
    });
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedTableName, setSelectedTableName] = useState('');
    const [prefixValue, setPrefixValue] = useState('');
    const { sessionId } = useSession();
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const activeStatus = localStorage.getItem("active_status");
    const templateType = localStorage.getItem("template_type");
    const stage = localStorage.getItem("stage");



    const apiSessionId = sessionStorage.getItem("sessionId");

    const department = sessionStorage.getItem("dept");


    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setvalidErrorRecords([]);
        try {
            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { dept: department }
            };
            const response = await axios.post(Makerlist_deptwisetemplates, {}, config);

            // let tables = [];
            // const response = await axios.post(viewtemplatelist, {}, config);

            const message = "Nothing pending for Upload data";

            if (response.data?.tables?.length) {
                // Categorize tables by prefix
                const categorizedTables = {};

                response.data.tables.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });


                setTableNames(categorizedTables);
            } else {
                // const updatedMessage = `Nothing pending for Upload data in department: ${department || 'Unknown'}`;
                // responseBKP(response, setModalMessage, setShowModal, setTableNames, message, updatedMessage);
                setTableNames({});
                const dept = sessionStorage.getItem("dept") || "Department not found";
                const updatedMessage = `Nothing pending for Upload data in department: ${dept}`;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // const ROE_DEFAULTS = {
    //     frequency: "Quarterly",
    //     criticality: "Level 1",
    //     ownership: "Finance and Planning",
    //     risk_area: "Earnings and financial performance",
    //     risk_indicator: "Return on Equity (ROE)",
    //     definition:
    //         "ROE is a financial ratio that measures the performance of the Bank based on its average shareholders' equity outstanding."
    // };

    // const ROE_LOCKED_FIELDS = [
    //     "frequency",
    //     "criticality",
    //     "ownership",
    //     "risk_area",
    //     "risk_indicator",
    //     "definition"
    // ];

    const RAF_COLUMN_MAP = {
        risk_indicator: "RISK_INDICATOR",
        definition: "DEFINITION",
        frequency: "MONITORING_FREQUENCY",
        criticality: "CRITICALITY_LEVEL",
        ownership: "OWNERSHIP"
    };

    const RAF_DISABLED_FIELDS = [
        "definition",
        "frequency",
        "criticality",
        "ownership"
    ];

    const TEMPLATE_CONFIG = {
        Risk_return_on_equity: {
            defaults: {
                frequency: "Quarterly",
                criticality: "Level 1",
                ownership: "Finance and Planning",
                risk_area: "Earnings and financial performance",
                risk_indicator: "Return on Equity (ROE)",
                definition:
                    "ROE is a financial ratio that measures the performance of the Bank based on its average shareholders' equity outstanding."
            },
            lockedFields: [
                "frequency",
                "criticality",
                "ownership",
                "risk_area",
                "risk_indicator",
                "definition"
            ],
            staticDisabledFields: [
                "annualized_net_profit",
                "average_shareholders_equity"
            ]
        },

        HR_overall_saudization_rate: {
            defaults: {
                frequency: "Quarterly",
                criticality: "Level 1",
                ownership: "Human Resources Group",
                risk_area: "People and Conduct Risk",
                risk_indicator: "Overall Saudization Rate (OSR)",
                definition:
                    "The overall Saudization rate reflects compliance with local labor regulations and the bank’s commitment to nationalization objectives."
            },
            lockedFields: [
                "frequency",
                "criticality",
                "ownership",
                "risk_area",
                "risk_indicator",
                "definition"
            ],
            staticDisabledFields: [
                "total_employees_saudi_national",
                "total_employees"
            ]
        }
    };


    useEffect(() => {
        const fetchFormStructure = async () => {
            if (!selectedTableName) return;

            setLoading(true);
            try {
                const param = selectedTableName;
                const paramWithoutPrefix = param.includes('_') ? param.split('_').slice(1).join('_') : param;


                setParam(param);
                setFormName(paramWithoutPrefix);

                // const responsefromFile = await fetch(`${PortURL}/demformtemplate/${param}.json`);
                const responsefromFile = await fetch(`/demformtemplate/${param}.json`);
                if (!responsefromFile.ok) {
                    throw new Error('Nothing pending for Modification');
                }

                const responsetxt = await responsefromFile.json();

                if (
                    responsetxt.tableName === "Risk_return_on_equity" ||
                    responsetxt.tableName === "HR_overall_saudization_rate"
                ) {
                    responsetxt.details = responsetxt.details.map(detail => {
                        const column = detail.columnName.toLowerCase();

                        // ✅ Value column → %
                        if (column === "value") {
                            return {
                                ...detail,
                                columnLabel: `${detail.columnLabel} (%)`
                            };
                        }

                        // ✅ Other specific numeric fields → Value in SAR
                        const sarFields = [
                            "annualized_net_profit",
                            "average_shareholders_equity",
                            // "total_employees_saudi_national",
                            // "total_employees"
                        ];

                        if (sarFields.includes(column)) {
                            return {
                                ...detail,
                                columnLabel: `${detail.columnLabel} (Value in SAR-Bn)`
                            };
                        }

                        return detail;
                    });
                }


                // Initialize form data
                const initialFormData = {};
                responsetxt.details.forEach(detail => {
                    if (detail.columnActive === "N") {
                        if (
                            !detail.columnKey ||
                            detail.columnKey.toLowerCase() === "null" ||
                            detail.columnKey.toLowerCase() === "not null"
                        ) {
                            switch (detail.columnType.toUpperCase()) {
                                case 'INT':
                                case 'INTEGER':
                                    initialFormData[detail.columnName] = 0;
                                    break;
                                case 'VARCHAR':
                                case 'CHAR':
                                case 'TEXT':
                                    initialFormData[detail.columnName] = 'N';
                                    break;
                                case 'DATE':
                                    initialFormData[detail.columnName] = '1900-01-01';
                                    break;
                                default:
                                    initialFormData[detail.columnName] = null;
                            }
                        }
                    } else {
                        initialFormData[detail.columnName] = '';
                    }
                });

                //  STEP: Pre-calculate computed fields before setting to state


                const preCalculated = calculateDynamicFields(initialFormData, responsetxt);

                let finalData = { ...preCalculated };

                // if (responsetxt.tableName === "ANB_return_on_equity") {
                //     finalData = {
                //         ...finalData,
                //         ...ROE_DEFAULTS
                //     };
                // }

                const templateConfig = TEMPLATE_CONFIG[responsetxt.tableName];

                if (templateConfig) {
                    finalData = {
                        ...finalData,
                        ...templateConfig.defaults
                    };
                }

                // ✅ Inject dropdown options for risk_indicator
                if (
                    rafTableName &&
                    rafTableName.toLowerCase() === paramWithoutPrefix.toLowerCase() &&
                    rafData.length > 0
                ) {
                    const riskIndicatorOptions = [...new Set(
                        rafData.map(item => item.RISK_INDICATOR?.trim())
                    )];
                    console.log("RAF DATA:", rafData);
                    console.log("RAF TABLE:", rafTableName);
                    console.log("PARAM:", paramWithoutPrefix);

                    responsetxt.details = responsetxt.details.map(detail => {
                        if (detail.columnName.toLowerCase() === "risk_indicator") {
                            return {
                                ...detail,
                                columnFunction: `dropdown:[${riskIndicatorOptions.join(",")}]`
                            };
                        }
                        return detail;
                    });
                }

                setFormStructure(responsetxt);

                // Set form data into correct tab state
                if (activeTab === 'manual') {
                    // setManualFormData(preCalculated);
                    setManualFormData(finalData);
                } else {
                    // setAIFormData(preCalculated);
                    setAIFormData(finalData);

                }

            } catch (error) {
                console.error('Error fetching form structure:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchFormStructure();
    }, [selectedTableName, activeTab, rafData, rafTableName]);
    // Run when table or tab changes


    const handleImmediateNotify = async () => {
        try {
            await handleUploadAndNotify('IN');
            setConfirmationMessage('Immediate notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending immediate notification.');
        }
    };

    const handleEodNotify = async () => {
        try {
            await handleUploadAndNotify('EOD');
            setConfirmationMessage('End of day notification sent successfully.');
        } catch (error) {
            setConfirmationMessage('Error sending end of day notification.');
        }
    };


    useEffect(() => {
        console.log("Updated selectedLayout:", selectedLayout);
    }, [selectedLayout]);


    const handledatatype = (dataType) => {
        setDataType(dataType);
        // setShowDropdown(false);
        // setPopShowModal(true);
        // Ensure API uses the latest value
        setTimeout(() => {
            console.log("Updated selecteddataType (delayed):", dataType);
        }, 100);
    };


    // Single handleSubmit function to check and call the appropriate function
    const handleFormSubmit = async () => {
        setFormSubmitted(true); // Mark form as submitted
        setShowNotifyModal(false); // Close the notification modal

        // Check the selected notification type and call the corresponding function
        if (notifyType === 'IN') {
            await handleImmediateNotify();
        } else if (notifyType === 'EOD') {
            await handleEodNotify();
        }

        // After calling either function, show confirmation modal
        setShowConfirmationModal(true); // Show the confirmation modal
        setShowNotifyModalAfterConfirmation(true); // Flag to show notify modal after confirmation
    };

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile && !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(selectedFile.type)) {
            setUploadStatus('Only PDF, JPG, and PNG files are allowed.');
            setFile(null);
            setSelectedFile(null);
            return;
        }

        setSelectedFile(selectedFile);

        try {
            setLoading(true);
            setErrMsg('');
            setIsUploadAllowed(true);
            setFile(selectedFile);
            setUploadStatus('');
        } catch (error) {
            console.error('Error converting file:', error.message);
            setUploadStatus('Error converting file.');
            setIsUploadAllowed(false);
        } finally {
            setLoading(false);
        }
    };

    const handleUploadAndNotify = async (notifyType) => {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append('file', file);

            // const uploadResponse = await axios.post('http://172.16.119.156:3001/uploadocrfiles', formData, {
            const uploadResponse = await axios.post(mqemocr, formData, {

                headers: {
                    'Content-Type': 'multipart/form-data',
                    'userId': localStorage.getItem('userid'),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
            });

            if (uploadResponse.status === 200) {
                const fileName = file.name;
                const fileNameNoExt = fileName.replace('.txt', '');
                const filePath = "/sasdepot/dgms/frontend/d-v3/files/uploadocrfiles/";
                setLoading(false);
                setWsLoading(false);
                await callAdditionalApi(fileNameNoExt, filePath, notifyType, selectedLayout, dataType);

                // Reset form after successful upload
                handleClearFile();
                setPopShowModal(false); // Close the preview modal if it's open
            }
        } catch (uploadError) {
            setLoading(false); // Make sure to stop upload spinner in case of error
            setWsLoading(false);
            if (uploadError.response && uploadError.response.status === 409) { // Assuming 409 Conflict for file already exists
                setUploadStatus('File already exists.');
                setPopShowModal(false); // Close the preview modal if open

                setShowNotifyModal(true); // Show notification modal for file exists
                setModalMessage(uploadError.response.data.message); // Set modal message
            } else {
                console.error('Error uploading file:', uploadError.response ? uploadError.response.data : uploadError.message);
                setUploadStatus('Error uploading file.');
            }
        } finally {
            setLoading(false);
        }
    };

    // const handleValueModeChange = (mode) => {
    //     setValueMode(mode);

    //     // Clear form data for both tabs
    //     setManualFormData({});
    //     setAIFormData({});

    //     // Optional: clear modal if open
    //     setModalMessage('');
    // };

    // const handleValueModeChange = (mode) => {
    //     setValueMode(mode);


    //     const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];

    //     if (templateConfig) {
    //         setManualFormData({
    //             ...templateConfig.defaults
    //         });

    //         setAIFormData({
    //             ...templateConfig.defaults
    //         });
    //     } else {
    //         setManualFormData({});
    //         setAIFormData({});
    //     }

    //     // Clear error states when switching modes
    //     setModalMessage('');
    //     setMessageType('');
    // };

    const handleValueModeChange = (mode) => {
        setValueMode(mode);

        const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];

        setManualFormData(prev => {
            let updated = { ...prev };

            if (templateConfig) {
                updated = {
                    ...updated,
                    ...templateConfig.defaults
                };

                // If static mode → clear disabled fields
                if (mode === "static" && templateConfig.staticDisabledFields) {
                    templateConfig.staticDisabledFields.forEach(field => {
                        updated[field] = "";
                    });
                }
            }

            return updated;
        });

        setAIFormData(prev => {
            let updated = { ...prev };

            if (templateConfig) {
                updated = {
                    ...updated,
                    ...templateConfig.defaults
                };

                if (mode === "static" && templateConfig.staticDisabledFields) {
                    templateConfig.staticDisabledFields.forEach(field => {
                        updated[field] = "";
                    });
                }
            }

            return updated;
        });

        setModalMessage('');
        setMessageType('');
    };


    const handleClosePopup = () => {
        setPopShowModal(false);
        setPopupData(null);
        setPopupCallback(null);
        setSelectedIndex(null)
    };

    const handleSubmitPopup = (selectedRowData) => {
        if (activeTab !== 'ai') return;

        if (popupCallback) {
            popupCallback(selectedRowData); // this should call handleParsedData
        }

        setAIFormData(prev => ({
            ...prev,
            ...selectedRowData, // or process this through handleParsedData if needed
        }));

        setSelectedIndex(null);
    };



    const callAdditionalApi = async (fileName, filePath, notifyType, selectedLayout, dataType) => {
        setWsLoading(true);
        const socket = new WebSocket(OcrWebsocket);

        socket.onopen = async () => {

            // Extract the file format and file name dynamically
            const format = fileName.substring(fileName.lastIndexOf('.')); // Extract file extension (e.g., '.pdf' or '.jpg')
            const fileNameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.')); // Extract file name without extension


            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'),
                    "sessionId": "300fafd8-77a4-4d1d-8f6a-6a5594f19fe4",
                    "x-csrf-token": csrfToken
                },
                params: {
                    "fileName": fileNameWithoutExtension,
                    "dataModel": "DEM",
                    "role": userRole,
                    "format": format,
                    // "dataFormat": "vertical",
                    "dataFormat": selectedLayout,
                    "dataType": dataType,
                    "dept": prefixValue
                },
                withCredentials: true,
            };

            try {
                const response = await axios.post(OcrMethod, {}, config);
                console.log("API response:", response.data);
            } catch (error) {
                console.error("API error:", error);
                setWsLoading(false);
            }
        };

        socket.onmessage = async (event) => {
            try {
                const responseData = JSON.parse(event.data);
                console.log("WebSocket message received:", responseData);
                setWsLoading(false);

                if (!responseData.data) {
                    console.error("Missing 'data' field in WebSocket message.");
                    setWsLoading(false);
                    return;
                }

                let selectedData;

                if (responseData.text === "multipledata") {
                    let dataToParsedTable;

                    // 1. Parse inner JSON string if needed
                    if (typeof responseData.data === "string") {
                        const inner = JSON.parse(responseData.data);
                        dataToParsedTable = typeof inner.JSON_DATA === "string"
                            ? JSON.parse(inner.JSON_DATA)
                            : inner.JSON_DATA;
                    }

                    // 2. Determine row count
                    let rowCount = 0;
                    if (Array.isArray(dataToParsedTable)) {
                        rowCount = dataToParsedTable.length;
                    } else if (typeof dataToParsedTable === 'object' && dataToParsedTable !== null) {
                        const values = Object.values(dataToParsedTable);
                        if (values.length > 0 && values.every(arr => Array.isArray(arr))) {
                            rowCount = values[0].length;
                        }
                    }

                    // 3. If only one row, extract without showing popup
                    if (rowCount === 1) {
                        if (Array.isArray(dataToParsedTable)) {
                            selectedData = dataToParsedTable[0];
                        } else {
                            selectedData = {};
                            Object.keys(dataToParsedTable).forEach(key => {
                                selectedData[key] = dataToParsedTable[key][0];
                            });
                        }
                    } else {
                        // 4. Show popup if multiple rows
                        console.log("Waiting for user selection...");
                        // selectedData = await showPopupTableAsync(dataToParsedTable);
                        if (activeTab === 'ai') {
                            selectedData = await showPopupTableAsync(dataToParsedTable);
                        } else {
                            console.warn("Popup skipped because activeTab is NOT 'ai'");
                            return;
                        }

                    }


                }

                let parsedData;
                if (responseData.text === "multipledata") {
                    parsedData = typeof selectedData === "string"

                        ? JSON.parse(selectedData)
                        : selectedData;
                } else {
                    if (typeof responseData.data === "string") {
                        const innerData = JSON.parse(responseData.data); // Parse the 'data' field
                        parsedData = typeof innerData.JSON_DATA === "string"

                            ? JSON.parse(innerData.JSON_DATA)
                            : innerData.JSON_DATA;
                    } else if (typeof responseData.data.JSON_DATA === "object") {
                        parsedData = responseData.data.JSON_DATA; // Use as-is if it's already an object
                    } else {
                        throw new Error("'JSON_DATA' is undefined or invalid.");
                    }
                }

                // Sanitize keys in parsedData
                const sanitizedData = sanitizeKeys(parsedData);
                // Process parsed data
                handleParsedData(sanitizedData);

            } catch (error) {
                console.error("Error processing WebSocket message:", error.message);

            }
            finally {
                setWsLoading(false);
            }
        };



        function showPopupTableAsync(data) {
            return new Promise((resolve) => {
                showPopupTable(data, resolve);
                setPopShowModal(true); // Show modal here
            });
        }

        function showPopupTable(data, callback) {
            setPopupData(data);
            setPopupCallback(() => (selectedRow) => {
                if (activeTab === 'ai') {
                    callback(selectedRow); // run only if AI tab is active
                }
            });
        }

        const sanitizeKeys = (data) => {
            const sanitized = {};

            for (const key in data) {

                if (data.hasOwnProperty(key)) {
                    // Normalize key to uppercase
                    let sanitizedKey = key.toUpperCase();

                    // Check if the key ends with "DATEE" and sanitize it
                    if (sanitizedKey.endsWith("DATEE")) {
                        sanitizedKey = sanitizedKey.slice(0, -1); // Remove the last character
                    }

                    // Recursively sanitize if the value is an object
                    if (typeof data[key] === "object" && !Array.isArray(data[key])) {
                        sanitized[sanitizedKey] = sanitizeKeys(data[key]);
                    } else {
                        sanitized[sanitizedKey] = data[key];
                    }
                }
            }

            return sanitized;

        };

        const handleParsedData = (parsedData) => {

            const convertDateFormat = (dateStr) => {
                dateStr = dateStr.replace(/\D/g, '');
                if (!dateStr || dateStr.length !== 8) return '';
                const day = dateStr.slice(0, 2);
                const month = dateStr.slice(2, 4);
                const year = dateStr.slice(4);
                return `${year}-${month}-${day}`;
            };

            const normalizeKey = (key) => key.replace(/[\s_]/g, '').toLowerCase();

            const updateFormData = (prevFormData) => {
                const normalizedPrev = Object.fromEntries(
                    Object.entries(prevFormData).map(([key, value]) => [normalizeKey(key), value])
                );

                const updatedFormData = { ...prevFormData }; // preserve actual keys used in inputs

                for (const [key, value] of Object.entries(parsedData)) {
                    const normKey = normalizeKey(key);

                    // Find actual key from prevFormData or use as-is
                    const actualKey = Object.keys(prevFormData).find(
                        originalKey => normalizeKey(originalKey) === normKey
                    );

                    const finalKey = actualKey || key;

                    updatedFormData[finalKey] = normKey.includes("date")
                        ? convertDateFormat(value)
                        : value;
                }

                return updatedFormData;
            };

            if (activeTab === 'manual') {
                setManualFormData(prev => updateFormData(prev));
            } else if (activeTab === 'ai') {
                setAIFormData(prev => updateFormData(prev));
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            console.log("WebSocket connection closed");
        };

    };

    const handleClearFile = () => {
        setSelectedFile(null);
        setFile(null);
        setUploadSuccess(false);
        setErrMsg('');
        setDataType('');
        setSelectedOrientation(""); // Reset to default or empty string if preferred
        setSelectedLayout('');
        setRecordType('');
    };

    const isDateString = (val) => {
        if (typeof val !== "string") return false;
        // Matches YYYY-MM-DD, MM/DD/YYYY, or ISO-like formats
        return /^\d{4}-\d{2}-\d{2}$/.test(val) || /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val);
    };


    const calculateDynamicFields = (newFormData, formStructure) => {
        setMessageType("");
        setModalMessage("");
        if (!formStructure) return newFormData;

        if (valueMode === "static") {
            return newFormData;
        }

        const details = formStructure.details;
        let calculatedData = { ...newFormData };

        details.forEach(detail => {
            const formula = detail.columnFunction?.trim();
            if (!formula) return;

            const columnName = detail.columnName;

            // 🚫 Skip dropdown definitions - they are not formulas
            if (formula.startsWith('dropdown:')) {
                return; // Skip processing for dropdowns
            }

            try {
                let expression = formula;

                // 🧩 1️⃣ Handle Function-style like Addition(a,b)
                const funcMatch = expression.match(/^(\w+)\s*\(([^)]*)\)$/i);
                if (funcMatch) {
                    const funcName = funcMatch[1];
                    const operands = funcMatch[2].split(',').map(o => o.trim());

                    // Resolve operand values (from form data or constants)
                    // const resolvedArgs = operands.map(op => calculatedData[op] ?? op);
                    // Resolve operand values in a case-insensitive way
                    const resolvedArgs = operands.map(op => {
                        const operandLower = op.toLowerCase();

                        // Find matching field ignoring case
                        const matchingKey = Object.keys(calculatedData).find(
                            k => k.toLowerCase() === operandLower
                        );

                        // If matched → return value
                        if (matchingKey) return calculatedData[matchingKey];

                        // Otherwise constant value or raw text
                        return op;
                    });
                    // 🔍 Validate numeric inputs before calculation
                    const hasInvalidNumber = resolvedArgs.some(arg => {
                        if (arg === null || arg === undefined || arg === "") return false;

                        // If it's already a valid number, fine
                        if (/^-?\d+(\.\d+)?$/.test(String(arg).trim())) return false;


                        // If it's a date string, allow (your existing date logic handles it)
                        if (isDateString(arg)) return false;

                        return true; // invalid numeric value detected
                    });

                    if (hasInvalidNumber) {
                        setMessageType("danger");
                        setModalMessage("Only numeric values are allowed for calculation fields.");
                        return calculatedData; // ✅ IMPORTANT
                    }

                    const toNum = (x) => parseFloat(x) || 0;
                    const [a, b, c, d, e, f] = resolvedArgs.map(toNum);

                    switch (funcName.toLowerCase()) {
                        // 🧮 Math & arithmetic
                        case 'addition':
                        case 'add': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && !isNaN(toNum(valB))) {
                                // Add days to a date
                                const d = new Date(valA);
                                d.setDate(d.getDate() + toNum(valB));
                                calculatedData[columnName] = d.toISOString();
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric addition
                                calculatedData[columnName] = toNum(valA) + toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }

                        case 'subtraction':
                        case 'subtract': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && isDateB) {
                                // ✅ Date difference in days
                                const diffMs = new Date(valA) - new Date(valB);
                                calculatedData[columnName] = diffMs / (1000 * 60 * 60 * 24);
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric subtraction
                                calculatedData[columnName] = toNum(valA) - toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }

                        case 'multiplication':
                        case 'multiply':
                            calculatedData[columnName] = a * b;
                            return;
                        case 'division':
                        case 'divide': {
                            let result = b !== 0 ? a / b : 0;

                            // ✅ Multiply by 100 only for Value column in specific templates
                            if (
                                (formStructure?.tableName === "Risk_return_on_equity" ||
                                    formStructure?.tableName === "HR_overall_saudization_rate") &&
                                columnName.toLowerCase() === "value"
                            ) {
                                result = result * 100;
                                result = parseFloat(result.toFixed(2)); // ✅ Round to 2 decimals
                            }

                            calculatedData[columnName] = result;

                            // ✅ Validation after multiplying
                            // if (
                            //     formStructure?.tableName === "Finance_return_on_equity" &&
                            //     columnName.toLowerCase() === "value" &&
                            //     result > 100
                            // ) {
                            //     setMessageType("danger");
                            //     setModalMessage("Return on Equity (ROE) exceeds the maximum limit of 100%");
                            // }
                            // else if (
                            //     formStructure?.tableName === "HR_overall_saudization_rate" &&
                            //     columnName.toLowerCase() === "value" &&
                            //     result > 100
                            // ) {
                            //     setMessageType("danger");
                            //     setModalMessage("Overall Saudization Rate (OSR) exceeds the maximum limit of 100%");
                            // }

                            return;
                        }

                        // 🕒 Date/Time-based functions
                        case 'now':
                            const now = new Date();
                            const formatted =
                                now.getFullYear() +
                                '-' +
                                String(now.getMonth() + 1).padStart(2, '0') +
                                '-' +
                                String(now.getDate()).padStart(2, '0') +
                                ' ' +
                                String(now.getHours()).padStart(2, '0') +
                                ':' +
                                String(now.getMinutes()).padStart(2, '0') +
                                ':' +
                                String(now.getSeconds()).padStart(2, '0');
                            calculatedData[columnName] = formatted;
                            return;

                        case 'year':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getFullYear();
                            return;
                        case 'month':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getMonth() + 1;
                            return;
                        case 'quarter':
                            calculatedData[columnName] = Math.floor((new Date(resolvedArgs[0]).getMonth() + 3) / 3);
                            return;
                        case 'second':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getSeconds();
                            return;
                        case 'dayofmonth':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDate();
                            return;
                        case 'dayofweek':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDay();
                            return;

                        case 'weeknumber': {
                            const inputDate = new Date(resolvedArgs[0]);
                            if (isNaN(inputDate)) {
                                calculatedData[columnName] = null;
                                return;
                            }

                            const target = new Date(inputDate.valueOf());
                            const dayNr = (inputDate.getDay() + 6) % 7; // Monday = 0
                            target.setDate(target.getDate() - dayNr + 3);
                            const firstThursday = new Date(target.getFullYear(), 0, 4);
                            const weekNo = 1 + Math.round(
                                ((target - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7
                            );

                            calculatedData[columnName] = weekNo;
                            return;
                        }
                        case 'dayofyear': {
                            const d = new Date(resolvedArgs[0]);
                            const start = new Date(d.getFullYear(), 0, 0);
                            const diff = d - start;
                            calculatedData[columnName] = Math.floor(diff / (1000 * 60 * 60 * 24));
                            return;
                        }

                        case 'datefrommdy': {
                            const [m, dy, y] = operands.map(o => toNum(calculatedData[o]) || toNum(o));
                            calculatedData[columnName] = `${y}-${String(m).padStart(2, '0')}-${String(dy).padStart(2, '0')}`;
                            return;
                        }

                        case 'datefromyq': {
                            const [yArg, qArg] = operands;
                            const yVal = new Date(calculatedData[yArg] || yArg).getFullYear() || toNum(yArg);
                            const qVal = toNum(calculatedData[qArg]) || 1;
                            const month = (qVal - 1) * 3 + 1;
                            calculatedData[columnName] = `${yVal}-${String(month).padStart(2, '0')}-01`;
                            return;
                        }

                        default:
                            console.warn(`⚠️ Unknown operator: ${funcName}`);
                            return;
                    }
                }

                // 🧮 2️⃣ Handle direct mathematical expressions
                const fieldNames = Object.keys(calculatedData);
                // 🔍 Validate numeric values for direct expressions
                const invalidField = Object.keys(calculatedData).find(field => {
                    if (!expression.includes(field)) return false;

                    const value = calculatedData[field];

                    if (value === null || value === undefined || value === "") return false;

                    if (/^-?\d+(\.\d+)?$/.test(String(value).trim())) return false;


                    return true;
                });

                if (invalidField) {
                    setMessageType("danger");
                    setModalMessage(`Only numeric values are allowed. Invalid value in "${invalidField}".`);
                    return calculatedData; // ✅ IMPORTANT
                }

                fieldNames.forEach(field => {
                    const value = parseFloat(calculatedData[field]);
                    const safeValue = isNaN(value) ? 0 : value;
                    const regex = new RegExp(`\\b${field}\\b`, 'g');
                    expression = expression.replace(regex, safeValue);
                });

                if (!/^[\d+\-*/().\s]+$/.test(expression)) {
                    console.warn(`Unsafe expression skipped for ${columnName}: ${expression}`);
                    return;
                }

                // 🧠 3️⃣ Evaluate math expression safely
                // eslint-disable-next-line no-new-func
                const result = Function(`"use strict"; return (${expression})`)();
                calculatedData[columnName] = isFinite(result) ? result : 0;

            } catch (err) {
                console.error(`Error evaluating formula for ${detail.columnName}:`, err);
            }
        });

        return calculatedData;
    };


    const handleBackClick = () => {
        navigate('/Templateformlist');
    };


    const handleErrorClick = () => {
        // Handle the error without navigating the page
        console.log('Error occurred. Handling it without navigation.');
    };

    const handleModalClose = () => {
        if (modalMessage === 'success') {
            handleBackClick(); // Only navigate if success
        } else {
            setModalMessage(''); // Close modal in case of an error
            handleErrorClick(); // Handle error without navigation
        }
    };

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };



    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click();
    };



    const showMessageModal = (message, type, shouldNavigate = false) => {
        const formattedMessage = message.replace(/\n/g, '<br/>'); // Only convert line breaks
        setModalMessage(formattedMessage); // No HTML tags like <span> or inline styles
        setMessageType(type);              // 'success' | 'warning' | 'error'
        setShowModal(true);
        setNavigateOnClose(shouldNavigate);
    };



    const handleSubmit = async (event) => {
        event.preventDefault();


        // Normalize `formData` keys to lowercase
        const normalizedFormData = Object.fromEntries(
            Object.entries(manualFormData).map(([key, value]) => [key.toLowerCase(), value])
        );

        console.log("Normalized formData:", normalizedFormData);

        // const currentFormData = activeTab === 'manual' ? manualFormData : aiFormData;
        // // ✅ Validation for Return on Equity 
        // const roe = parseFloat(currentFormData.return_on_equity);
        const currentFormData = activeTab === 'manual' ? manualFormData : aiFormData;

        const normalizedCurrentData = Object.fromEntries(
            Object.entries(currentFormData).map(([key, value]) => [key.toLowerCase(), value])
        );

        const roe = parseFloat(normalizedCurrentData["return_on_equity"]);
        if (formStructure?.tableName === "Risk_return_on_equity") {

            const valueField = parseFloat(normalizedCurrentData["value"]);

            if (!isNaN(valueField) && valueField > 100) {
                setMessageType("danger");
                setModalMessage("Return on Equity (ROE) exceeds the maximum limit of 100%");
                return;
            }
            // else if (formStructure?.tableName === "ANB_overall_saudization_rate") {
            //     setMessageType("danger");
            //     setModalMessage("Overall Saudization Rate exceeds the maximum limit of 100%");
            //     return;
            // }
        }

        if (formStructure?.tableName === "HR_overall_saudization_rate") {

            const valueField = parseFloat(normalizedCurrentData["value"]);

            if (!isNaN(valueField) && valueField > 100) {
                setMessageType("danger");
                setModalMessage("Overall Saudization Rate exceeds the maximum limit of 100%");
                return;
            }
            // else if (formStructure?.tableName === "ANB_overall_saudization_rate") {
            //     setMessageType("danger");
            //     setModalMessage("Overall Saudization Rate exceeds the maximum limit of 100%");
            //     return;
            // }
        }


        const missingFields = [];

        for (const field of formStructure.details) {
            const isActive = field.columnActive !== 'N';
            const isNotNull = field.columnKey === 'NOT NULL';
            const isPrimaryKey = field.columnKey === 'PRIMARY KEY';
            const fieldValue = normalizedFormData[field.columnName.toLowerCase()];

            if ((isNotNull && isActive && !fieldValue) || (isPrimaryKey && !fieldValue)) {
                missingFields.push(field.columnLabel.toUpperCase());
            }
        }

        if (missingFields.length > 0) {
            const formattedFields = missingFields
                .map(
                    (field, index) =>
                        `<span class="text-warning" style="font-size:14px; font-family:verdana">${field}${index < missingFields.length - 1 ? ',' : ''}</span>`
                )
                .join(' ');


            const message = `<span style="color: rgba(255, 193, 7, 1); font-size:14px; font-family:verdana;">⚠️ The following fields are missing:</span><br/>${formattedFields}`;


            showMessageModal(message, 'warning'); // Show warning modal in yellow
            return;
        }

        // Show the notification modal after successful data submission
        // setShowNotificationModal(true);
        handleNotificationSubmit();

    };

    const handleNotificationSubmit = async () => {
        try {
            const filename = selectedFileName + ".json";
            const content = JSON.stringify([manualFormData], null, 2);

            // Create text file on server
            // await axios.post('http://172.16.119.156:3001/create-text-file', { filename, content });
            // await axios.post(createTextFileApi, { filename, content });
            await axios.post(
                createTextFileApi,
                { filename, content },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'userId': localStorage.getItem('userid'),
                        "x-csrf-token": csrfToken,
                    },
                    withCredentials: true,
                }
            );



            // Submit data with the selected notification type
            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    "filePath": "/saswork/nas/" + filename,
                    "dataModel": "DEM",
                    "tableName": selectedFileName,
                    "Notifications": "IN",// Include notificationType here
                    "templateType": "DemDataUpload",
                    "dept": prefixValue

                }
            };
            // const responseDb = await axios.post('http://172.16.119.156:8081/api/submitdata/dem', {}, config);

            const responseDb = await axios.post(demformdata, {}, config);

            if (responseDb.status === 200) {
                // Clear the form data
                // const initialFormData = {};
                // formStructure.details.forEach(detail => {
                //     initialFormData[detail.columnName] = '';
                // });
                // setManualFormData(initialFormData); // For manual
                // // OR
                // setAIFormData(initialFormData);     // For OCR

                // let initialFormData = {};

                // formStructure.details.forEach(detail => {
                //     initialFormData[detail.columnName] = '';
                // });

                // if (formStructure?.tableName === "ANB_return_on_equity") {
                //     // Keep locked ROE fields
                //     initialFormData = {
                //         ...initialFormData,
                //         ...ROE_DEFAULTS
                //     };
                // }

                // setManualFormData(initialFormData);
                // setAIFormData(initialFormData);

                let initialFormData = {};

                formStructure.details.forEach(detail => {
                    initialFormData[detail.columnName] = '';
                });

                const tableName = formStructure?.tableName;
                const templateConfig = TEMPLATE_CONFIG[tableName];

                if (templateConfig?.defaults) {
                    initialFormData = {
                        ...initialFormData,
                        ...templateConfig.defaults
                    };
                }

                setManualFormData(initialFormData);
                setAIFormData(initialFormData);


                // Store active_status and template_type in localStorage
                if (responseDb.data?.active_status && responseDb.data?.template_type) {
                    localStorage.setItem("active_status", responseDb.data.active_status);
                    localStorage.setItem("template_type", responseDb.data.template_type);
                    localStorage.setItem("stage", responseDb.data.stage);

                    console.log("Stored in localStorage:", {
                        active_status: responseDb.data.active_status,
                        template_type: responseDb.data.template_type,
                        stage: responseDb.data.stage,
                    });
                } else {
                    console.log("active_status or template_type is missing or response.data is null");
                }


                if (responseDb.data && responseDb.data.message) {
                    const message = responseDb.data.message;
                    if (responseDb.data.status === "success") {
                        showMessageModal(`1 record of <strong>${toTitleCase(selectedFileName)}</strong> Submitted Successfully`, 'success'); // Show success modal in green
                        setShowModal(true);
                    } else {
                        showMessageModal(message, 'error'); // Show error modal in red
                    }
                } else {
                    showMessageModal('Unknown error occurred', 'error'); // Fallback for unexpected cases
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error.message);
            showMessageModal('Error submitting data', 'error'); // Show error modal in red
        }

        setShowNotificationModal(false); // Close the notification modal
    };

    const handleOCRSubmit = async (event) => {
        event.preventDefault();


        // Normalize `formData` keys to lowercase
        const normalizedFormData = Object.fromEntries(
            Object.entries(aiFormData).map(([key, value]) => [key.toLowerCase(), value])
        );


        if (!formStructure) {
            console.error('Form structure not loaded yet.');
            return;
        }

        const missingFields = [];

        for (const field of formStructure.details) {
            const isActive = field.columnActive !== 'N';
            const isNotNull = field.columnKey === 'NOT NULL';
            const isPrimaryKey = field.columnKey === 'PRIMARY KEY';
            const fieldValue = normalizedFormData[field.columnName.toLowerCase()];

            if ((isNotNull && isActive && !fieldValue) || (isPrimaryKey && !fieldValue)) {
                missingFields.push(field.columnLabel);
            }
        }

        if (missingFields.length > 0) {
            const formattedFields = missingFields
                .map(
                    (field, index) =>
                        `<span class="text-warning" style="font-size:14px; font-family:verdana">${field}${index < missingFields.length - 1 ? ',' : ''}</span>`
                )
                .join(' ');


            const message = `<span style="color: rgba(255, 193, 7, 1); font-size:14px; font-family:verdana;">⚠️ The following fields are missing:</span><br/>${formattedFields}`;


            showMessageModal(message, 'warning'); // Show warning modal in yellow
            return;
        }

        // Show the notification modal after successful data submission
        // setShowNotificationModal(true);
        handleNotificationOCRSubmit();

    };

    const handleNotificationOCRSubmit = async () => {
        try {
            const filename = selectedFileName + ".json";
            const content = JSON.stringify([aiFormData], null, 2);

            // Create text file on server
            // await axios.post('http://172.16.119.156:3001/create-text-file', { filename, content });
            // await axios.post(createTextFileApi, { filename, content });
            await axios.post(
                createTextFileApi,
                { filename, content },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'userId': localStorage.getItem('userid'),
                        "x-csrf-token": csrfToken,
                    },
                    withCredentials: true,
                }
            );
            // Submit data with the selected notification type
            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: {
                    "filePath": "/saswork/nas/" + filename,
                    "dataModel": "DEM",
                    "tableName": selectedFileName,
                    "Notifications": "IN", // Include notificationType here
                    "templateType": "DEM OCR Upload",
                    "dept": prefixValue
                }
            };

            // const responseDb = await axios.post('http://172.16.119.156:8081/api/submitdata/dem', {}, config);

            const responseDb = await axios.post(demformdata, {}, config);

            if (responseDb.status === 200) {

                const initialFormData = {};
                formStructure.details.forEach(detail => {
                    initialFormData[detail.columnName] = '';
                });
                setManualFormData(initialFormData); // For manual
                // OR
                setAIFormData(initialFormData);     // For OCR

                // Store active_status and template_type in localStorage
                if (responseDb.data?.active_status && responseDb.data?.template_type) {
                    localStorage.setItem("active_status", responseDb.data.active_status);
                    localStorage.setItem("template_type", responseDb.data.template_type);
                    localStorage.setItem("stage", responseDb.data.stage);
                    console.log("Stored in localStorage:", {
                        active_status: responseDb.data.active_status,
                        template_type: responseDb.data.template_type,
                        stage: responseDb.data.stage,
                    });
                } else {
                    console.log("active_status or template_type is missing or response.data is null");
                }


                if (responseDb.data && responseDb.data.message) {
                    const message = responseDb.data.message;
                    if (responseDb.data.status === "success") {
                        showMessageModal(`1 record of <strong>${toTitleCase(selectedFileName)}</strong> Submitted Successfully`, 'success'); // Show success modal in green
                        // showMessageModal(`<strong>${toTitleCase(selectedFileName)}</strong> Submitted Successfully`, 'success'); // Show success modal in green
                        setShowModal(true);
                    } else {
                        showMessageModal(message, 'error'); // Show error modal in red
                    }
                } else {
                    showMessageModal('Unknown error occurred', 'error'); // Fallback for unexpected cases
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error.message);
            showMessageModal('Error submitting data', 'error'); // Show error modal in red
        }

        setShowNotificationModal(false); // Close the notification modal
    };

    // const renderInput = (detail, value, onChange) => {
    //     switch (detail.columnType.toLowerCase()) {
    //         case 'date':
    //             return (
    //                 <input
    //                     type="date"
    //                     className="form-control form-control-sm"
    //                     name={detail.columnName}
    //                     value={value || ''}
    //                     onChange={(e) => onChange(e.target.value)}
    //                 />
    //             );

    //         case 'varchar':
    //             if (detail.columnFunction && detail.columnFunction.startsWith('dropdown')) {
    //                 const match = detail.columnFunction.match(/dropdown:\[([^\]]*)\]/);
    //                 const options = match && match[1] ? match[1].split(',') : [];

    //                 return (
    //                     <select
    //                         className="form-control form-control-sm"
    //                         name={detail.columnName}
    //                         value={value || ''}
    //                         onChange={(e) => onChange(e.target.value)}
    //                     >
    //                         <option value="">--Select--</option>
    //                         {options.length > 0
    //                             ? options.map(option => (
    //                                 <option key={option} value={option}>
    //                                     {option}
    //                                 </option>
    //                             ))
    //                             : <option value="">No options available</option>}
    //                     </select>
    //                 );
    //             }
    //             // Fallback to text input
    //             return (
    //                 <input
    //                     type="text"
    //                     className="form-control form-control-sm"
    //                     name={detail.columnName}
    //                     value={value || ''}
    //                     onChange={(e) => onChange(e.target.value)}
    //                 />
    //             );

    //         case 'int':
    //             return (
    //                 <input
    //                     type="number"
    //                     className="form-control form-control-sm"
    //                     name={detail.columnName}
    //                     value={value || ''}
    //                     onChange={(e) => onChange(e.target.value)}
    //                 />
    //             );

    //         default:
    //             return (
    //                 <input
    //                     type="text"
    //                     className="form-control form-control-sm"
    //                     name={detail.columnName}
    //                     value={value || ''}
    //                     onChange={(e) => onChange(e.target.value)}
    //                 />
    //             );
    //     }
    // };


    // Preprocess data for use in form
    const today = new Date().toISOString().split('T')[0];

    const renderInput = (detail, value, onChange, disabled = false) => {
        switch (detail.columnType.toLowerCase()) {

            case 'date':
                return (
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name={detail.columnName}
                        value={value || ''}
                        max={detail.columnName === 'reporting_date' ? today : undefined}
                        onChange={(e) => onChange(e.target.value)}
                        disabled={disabled}
                    />
                );

            case 'varchar':
                if (detail.columnFunction && detail.columnFunction.startsWith('dropdown')) {
                    const match = detail.columnFunction.match(/dropdown:\[([^\]]*)\]/);
                    const options = match && match[1] ? match[1].split(',') : [];

                    return (
                        <select
                            className="form-control form-control-sm"
                            name={detail.columnName}
                            value={value || ''}
                            onChange={(e) => onChange(e.target.value)}
                            disabled={disabled}
                        >
                            <option value="">--Select--</option>
                            {options.length > 0
                                ? options.map(option => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))
                                : <option value="">No options available</option>}
                        </select>
                    );
                }

                return (
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        name={detail.columnName}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value)}
                        disabled={disabled}
                    />
                );

            case 'int':
                return (
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        name={detail.columnName}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value)}
                        disabled={disabled}
                    />
                );

            default:
                return (
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        name={detail.columnName}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value)}
                        disabled={disabled}
                    />
                );
        }
    };


    // Preprocess data for use in form
    const preprocessFormData = (details, formData) => {
        const updatedFormData = { ...formData };

        details.forEach(detail => {
            if (detail.columnActive === "N") {
                if (detail.columnKey === "NOT NULL") {
                    switch (detail.columnType.toLowerCase()) {
                        case "date":
                            updatedFormData[detail.columnName] = "1970-01-01";
                            break;
                        case "int":
                            updatedFormData[detail.columnName] = 0;
                            break;
                        case "varchar":
                            updatedFormData[detail.columnName] = "";
                            break;
                        default:
                            updatedFormData[detail.columnName] = null;
                    }
                } else if (detail.columnKey === "NULL") {
                    updatedFormData[detail.columnName] = null;
                }
            }
        });

        return updatedFormData;
    };



    // Get current formStructure and formData based on tab
    const currentFormData = activeTab === 'manual' ? manualFormData : aiFormData;
    const setCurrentFormData = activeTab === 'manual' ? setManualFormData : setAIFormData;

    const handleInputChange = (columnName, value) => {
        if (!formStructure) return;

        if (activeTab === 'manual') {
            setManualFormData((prev) => {
                let updatedData = { ...prev, [columnName]: value };

                // ✅ Autofill when risk_indicator changes
                if (columnName.toLowerCase() === "risk_indicator") {

                    const normalize = (str) => str?.trim();

                    const selectedRow = rafData.find(
                        item => normalize(item.RISK_INDICATOR) === normalize(value)
                    );

                    if (selectedRow) {
                        formStructure.details.forEach(detail => {

                            const formKey = detail.columnName.toLowerCase();

                            // ✅ Use mapping instead of direct match
                            const apiKey =
                                RAF_COLUMN_MAP[formKey] || detail.columnName.toUpperCase();

                            if (selectedRow.hasOwnProperty(apiKey)) {
                                updatedData[detail.columnName] = selectedRow[apiKey];
                            }
                        });
                    }
                }

                // ✅ Recalculate computed fields AFTER autofill
                const recalculated = calculateDynamicFields(updatedData, formStructure);

                return recalculated;
            });

        } else if (activeTab === 'ai') {

            setAIFormData((prev) => {
                let updatedData = { ...prev, [columnName]: value };

                if (columnName.toLowerCase() === "risk_indicator") {

                    const selectedRow = rafData.find(
                        item => item.RISK_INDICATOR?.trim() === value?.trim()
                    );

                    if (selectedRow) {
                        formStructure.details.forEach(detail => {
                            const column = detail.columnName.toUpperCase();

                            if (selectedRow.hasOwnProperty(column)) {
                                updatedData[detail.columnName] = selectedRow[column];
                            }
                        });
                    }
                }

                const recalculated = calculateDynamicFields(updatedData, formStructure);

                return recalculated;
            });
        }
    };


    const handleFormReset = () => {
        const templateConfig = TEMPLATE_CONFIG[formStructure?.tableName];

        // Clear form values completely
        setManualFormData(prev => {
            const cleared = {};

            Object.keys(prev).forEach(key => {
                cleared[key] = "";
            });

            return cleared;
        });

        setAIFormData(prev => {
            const cleared = {};

            Object.keys(prev).forEach(key => {
                cleared[key] = "";
            });

            return cleared;
        });

        // Now re-apply mode rules cleanly
        handleValueModeChange(valueMode);

        // Other reset logic
        setSelectedFile(null);
        setFile(null);
        setUploadSuccess(false);
        setErrMsg('');
        setDataType('');
        setSelectedOrientation("");
        setSelectedLayout('');
        setRecordType('');
    };


    useEffect(() => {
        if (selectedPrefix) {
            // Set the filtered tables based on selectedPrefix
            setFilteredTables(tableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]); // Clear when no prefix is selected
        }
    }, [selectedPrefix, tableNames]);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleTableClick = async (item) => {
        if (!item) {
            console.warn("handleTableClick called with null or undefined item.");
            return;
        }

        setSelectedTableName(item);

        const parts = item.split('_');
        const prefix = parts[0];
        const tableNameWithoutPrefix = parts.slice(1).join('_');
        setPrefixValue(prefix);


        setvalidErrorRecords([]);

        const selectedName = tableNameWithoutPrefix;
        setSelectedFileName(selectedName);

        const config = {
            headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
            withCredentials: true,
            params: { "tableName": item, "modify": "Y" }
        };

        try {
            const response = await axios.post(allowmodifytemplate, {}, config);
            console.log("response", response);

            const { message, proceed } = response.data;

            if (proceed === "Yes") {
                // navigate(`/BDMupload?fileName=${item}`);
            } else {
                if (message === "No") {
                    setModalMessageOne(`${item} is under Review for Checker.`);
                } else {
                    setModalMessageOne(`${message}`);
                }
            }
        } catch (error) {
            console.error("Error during table click handling:", error);
            setModalMessageOne("An error occurred. Please try again.");
        }
        const config1 = {
            headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
            withCredentials: true,
            params: { "tableName": selectedName, dept: department }
        };

        try {
            const response = await axios.post(rafmapping, {}, config1);
            console.log("response", response);
            const apiresponse = response.data;
            setRafData(apiresponse.data || []);
            setRafTableName(apiresponse.tableName);
            console.log("tableName for raf (API)", apiresponse.tableName);

        } catch (error) {
            console.error("Error during table click handling:", error);
            setModalMessageOne("An error occurred. Please try again.");
        }
    };


    const filteredRecords = useMemo(() => {
        // if (!selectedPrefix) return [];
        if (!selectedPrefix || !tableNames || !tableNames[selectedPrefix]) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPrefix]);

    const sortedRecords = useMemo(() => {
        return [...filteredRecords].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords, searchQuery]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages = Math.ceil(sortedRecords.length / recordsPerPage);


    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart(); // Remove leading spaces
        setSearchQuery(input);

        const pageNumber = parseInt(input, 10);

        // Check if input is a valid page number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
            paginate(pageNumber);
        }
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyMdashboard');
        // Additional logic if needed
    };

    const handleMQem = (e) => {
        e.preventDefault();
        navigate('/gapsyMqem');
        // Additional logic if needed
    };

    const [selectedOrientation, setSelectedOrientation] = useState(""); // 'landscape' or 'portrait'
    const [recordType, setRecordType] = useState("");

    const handleOrientationClick = (orientation) => {
        setSelectedOrientation(orientation);
        setSelectedLayout(orientation);
        setRecordType(""); // Reset record type when changing orientation
    };



    {
        wsLoading && (
            <div className="loading-overlay">
                {/* <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div> */}
                <UploadLoadingIcon />
            </div>
        )
    }


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                    {/* <span className={styles.separator}>/</span> */}
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-input-cursor-text me-2"></i>2.1 Quick Entry
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            {/* <div className="gapsybdmupload-page"> */}
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-4 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center gap-2 mb-1">
                                            <div>
                                                <DepartmentDropdown
                                                    selectedPrefix={selectedPrefix}
                                                    setSelectedPrefix={setSelectedPrefix}
                                                    prefixes={prefixes}
                                                />
                                            </div>

                                            {/* Search Bar */}
                                            <div className="flex-grow-1">
                                                <Listoftablesearchbox1
                                                    searchQuery={searchQuery}
                                                    onSearchChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>

                                        <TableTemplateListGapsy
                                            currentRecords={currentRecords}
                                            ListofTableFontsize={ListofTableFontsize}
                                            handleTableClick={handleTableClick}
                                            currentPage={currentPage}  // Pass currentPage
                                            recordsPerPage={recordsPerPage}  // Pass recordsPerPage
                                        />
                                        {/* </div> */}
                                        {/* </div> */}
                                        {sortedRecords.length > recordsPerPage && (
                                            <PaginationComponentForm2
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                paginate={paginate}
                                                recordsPerPage={recordsPerPage}
                                                tableNames={sortedRecords} // ← pass sorted list
                                            />
                                        )}

                                        <PopupTableModal
                                            show={popShowModal}
                                            data={popupData}
                                            onClose={handleClosePopup}
                                            onSubmit={handleSubmitPopup}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body p-1">

                                        {/* Tabs */}
                                        <div className={tabStyles.tabContainer}>
                                            <div
                                                className={`${tabStyles.tab} ${activeTab === 'manual' ? tabStyles.activeTab : ''}`}
                                                onClick={() => {
                                                    setActiveTab('manual');
                                                    setSelectedPrefix('');
                                                    setSearchQuery('');
                                                    setManualFormData('');
                                                    setMessageType('');
                                                    setModalMessage('');
                                                    // setSelectedFileName('');

                                                }}
                                            >
                                                <i className="bi bi-pencil-square me-1"></i> Manual
                                            </div>
                                            <div
                                                className={`${tabStyles.tab} ${activeTab === 'ai' ? tabStyles.activeTab : ''}`}
                                                onClick={() => {
                                                    setActiveTab('ai');
                                                    setSelectedPrefix('');
                                                    setSearchQuery('');
                                                    setManualFormData('');
                                                    setMessageType('');
                                                    setModalMessage('');
                                                    // setSelectedFileName('');
                                                }}
                                            >
                                                <i className="bi bi-robot me-1"></i> AI-OCR
                                            </div>
                                        </div>
                                        {/* <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>
                                            {selectedFileName
                                                ?.split('_')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')}
                                        </h6>
                                        <div className="d-flex justify-content-center mb-3">
                                            <button
                                                type="button"
                                                className={`btn btn-sm me-2 ${valueMode === "raw" ? "btn-primary" : "btn-outline-primary"}`}
                                                onClick={() => handleValueModeChange("raw")}
                                            >
                                                Raw Value
                                            </button>

                                            <button
                                                type="button"
                                                className={`btn btn-sm ${valueMode === "static" ? "btn-primary" : "btn-outline-primary"}`}
                                                onClick={() => handleValueModeChange("static")}
                                            >
                                                Static Value
                                            </button>
                                        </div> */}
                                        <div className={`d-flex justify-content-between align-items-center mb-2 pb-1 mb-0 ${styles.borderBottom}`}>

                                            {/* 🔹 Left Side - File Name */}
                                            <h6>
                                                {selectedFileName
                                                    ?.split('_')
                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                    .join(' ')}
                                            </h6>

                                            {/* 🔹 Right Side - Buttons */}
                                            {activeTab === 'manual' && selectedFileName === 'return_on_equity' && (
                                                <div>
                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm me-2 ${valueMode === "raw" ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleValueModeChange("raw")}
                                                    >
                                                        Raw Field
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={`btn btn-sm ${valueMode === "static" ? "btn-primary" : "btn-outline-primary"}`}
                                                        onClick={() => handleValueModeChange("static")}
                                                    >
                                                        Actual Value
                                                    </button>
                                                </div>
                                            )}
                                        </div>



                                        {/* Tab Content */}
                                        {activeTab === 'manual' && (
                                            <>
                                                {formStructure?.details?.length > 0 ? (
                                                    <>
                                                        <div className={`mx-auto ${formStyles.customScrollForm}`} style={{ maxWidth: '600px' }}>
                                                            {(() => {
                                                                const processedFormData = preprocessFormData(formStructure.details, manualFormData);

                                                                return (
                                                                    <form className="form" onSubmit={handleSubmit}>
                                                                        {formStructure.details
                                                                            .filter((detail) => detail.columnActive !== "N")
                                                                            .map((detail, index) => {
                                                                                // const isComputed = detail.columnFunction &&
                                                                                //     detail.columnFunction.trim() !== "" &&
                                                                                //     !detail.columnFunction.startsWith('dropdown:');
                                                                                const debugFields = [
                                                                                    "annualized_net_profit",
                                                                                    "average_shareholders_equity",
                                                                                    "total_employees_saudi_national",
                                                                                    "total_employees"
                                                                                ];

                                                                                const isRAFDisabled =
                                                                                    RAF_DISABLED_FIELDS.includes(detail.columnName.toLowerCase());

                                                                                if (debugFields.includes(detail.columnName.toLowerCase())) {
                                                                                    console.log(
                                                                                        `Field: ${detail.columnName}`,
                                                                                        "Value:",
                                                                                        manualFormData[detail.columnName]
                                                                                    );
                                                                                }

                                                                                const isComputed = detail.columnFunction &&
                                                                                    detail.columnFunction.trim() !== "" &&
                                                                                    !detail.columnFunction.startsWith('dropdown:');

                                                                                const isStaticMode = valueMode === "static";
                                                                                const tableName = formStructure?.tableName;
                                                                                const templateConfig = TEMPLATE_CONFIG[tableName];


                                                                                const isTemplateLockedField =
                                                                                    templateConfig?.lockedFields?.includes(
                                                                                        detail.columnName.toLowerCase()
                                                                                    );

                                                                                const isStaticDisableField =
                                                                                    isStaticMode &&
                                                                                    templateConfig?.staticDisabledFields?.includes(
                                                                                        detail.columnName.toLowerCase()
                                                                                    );


                                                                                return (
                                                                                    <div className="form-group row mb-2" key={index}>
                                                                                        <label className="col-sm-4 col-form-label text-small label-black">
                                                                                            {detail.columnLabel
                                                                                                ?.replace(/_/g, ' ')
                                                                                                .toUpperCase()
                                                                                            }

                                                                                            {(detail.columnKey === "NOT NULL" || detail.columnKey === "PRIMARY KEY") && (
                                                                                                <span className="text-dark" style={{ marginLeft: '4px' }}>*</span>
                                                                                            )}
                                                                                        </label>
                                                                                        <div className="col-sm-7">
                                                                                            {/* ✅ Computed fields - render as disabled input directly */}
                                                                                            {isComputed ? (
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control form-control-sm"
                                                                                                    value={manualFormData[detail.columnName] || ''}
                                                                                                    // disabled={valueMode === "raw"}   //  Disabled only in raw mode
                                                                                                    // disabled={valueMode === "raw" || isROELockedField}
                                                                                                    disabled={
                                                                                                        valueMode === "raw" ||
                                                                                                        isTemplateLockedField ||
                                                                                                        isStaticDisableField ||
                                                                                                        isRAFDisabled
                                                                                                    }

                                                                                                    style={{
                                                                                                        backgroundColor: valueMode === "raw" ? '#f8f9fa' : '#ffffff',
                                                                                                        cursor: valueMode === "raw" ? 'not-allowed' : 'text'
                                                                                                    }}
                                                                                                    onChange={(e) =>
                                                                                                        handleInputChange(detail.columnName, e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            ) : (
                                                                                                renderInput(
                                                                                                    detail,
                                                                                                    manualFormData[detail.columnName] || '',
                                                                                                    (value) => handleInputChange(detail.columnName, value),
                                                                                                    isTemplateLockedField || isStaticDisableField || isRAFDisabled

                                                                                                )
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </form>
                                                                );
                                                            })()}
                                                        </div>

                                                        {/* Buttons shown *after* the form */}
                                                        <div className="form-group row mb-2 mt-1">
                                                            <div className="w-100 d-flex justify-content-center">
                                                                <input
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm me-3"
                                                                    value="Reset"
                                                                    onClick={handleFormReset}
                                                                />
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={handleSubmit}
                                                                >
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center mt-4 text-muted">
                                                        <strong>Choose Department and Template.</strong>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {wsLoading && (

                                            <div className="loading-overlay">
                                                <UploadLoadingIcon />
                                            </div>
                                        )
                                        }
                                        {activeTab === 'ai' && (
                                            <div className="row">
                                                {/* Left Column */}
                                                <div className={`col-md-4 pe-3 ${styles.verticalDivider}`} >
                                                    {/* Orientation Buttons */}
                                                    <div className={`d-flex align-items-center px-2 py-1 gap-3 mb-3 ${styles.borderBottom}`}>
                                                        <label className="fw-semibold mb-0 text-dark">File Orientation :</label>
                                                        {/* Landscape */}
                                                        <button
                                                            className={`btn btn-sm btn-outline-info d-flex align-items-center justify-content-center ${styles.orientation} ${selectedOrientation === "vertical" ? "active" : ""}`}
                                                            onClick={() => handleOrientationClick("vertical")}
                                                            title="Portrait"
                                                            style={{ width: "38px", height: "38px" }}
                                                        >
                                                            <i className="bi bi-file-earmark"></i>
                                                        </button>

                                                        {/* Portrait */}
                                                        <button
                                                            className={`btn btn-sm btn-outline-info d-flex align-items-center justify-content-center ${styles.orientation} ${selectedOrientation === "horizontal" ? "active" : ""}`}
                                                            onClick={() => handleOrientationClick("horizontal")}
                                                            title="Landscape"
                                                            style={{ width: "38px", height: "38px" }}
                                                        >
                                                            <i
                                                                className="bi bi-file-earmark"
                                                                style={{ transform: "rotate(90deg)", display: "inline-block" }}
                                                            ></i>
                                                        </button>
                                                    </div>

                                                    {/* Orientation Heading */}
                                                    {selectedOrientation && (
                                                        <>
                                                            {/* <h6 className="fw-bold text-center mb-2">
                                                                {selectedOrientation === "horizontal" ? "Vertical" : "Horizontal"}
                                                            </h6> */}

                                                            {/* Data Type Radio Buttons */}
                                                            <div className={`d-flex align-items-center px-2 gap-3 mb-2  ${styles.borderBottom}`}>
                                                                <label className="mb-0 fw-semibold text-dark mb-2">Record: </label>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="dataType"
                                                                        id="singleData"
                                                                        value="single_data"
                                                                        checked={dataType === "single_data"}
                                                                        onChange={(e) => handledatatype(e.target.value)}
                                                                    />
                                                                    <label className="form-check-label text-dark" htmlFor="singleData">
                                                                        Single
                                                                    </label>
                                                                </div>

                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="dataType"
                                                                        id="multipleData"
                                                                        value="multipledata"
                                                                        checked={dataType === "multipledata"}
                                                                        onChange={(e) => handledatatype(e.target.value)}
                                                                    />
                                                                    <label className="form-check-label text-dark" htmlFor="multipleData">
                                                                        Multiple
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* OCR Format Info */}
                                                    {selectedOrientation && dataType && (
                                                        <>
                                                            <div className={`small text-muted`}>
                                                                <strong>Supported OCR Formats: </strong>
                                                                {selectedOrientation === "landscape"
                                                                    ? "Landscape (*.pdf)"
                                                                    : "Portrait (*.jpg, *.pdf)"}
                                                            </div>

                                                            {/* File Upload Section */}
                                                            <div className="gapsybdmupload-page">
                                                                <div className={`rounded p-3 text-center w-100 mt-3 ${styles.uploadArea}`}>
                                                                    {selectedFile ? (
                                                                        <>
                                                                            <p className="mb-1 text-truncate">📄 File: {selectedFile.name}</p>
                                                                            <p className="mb-1">📏 File Size: {selectedFile.size} bytes</p>
                                                                        </>
                                                                    ) : (
                                                                        <p className="text-center mt-1">No file selected</p>
                                                                    )}
                                                                    <button className="btn btn-outline-link mt-2" onClick={handleBrowseClick}>
                                                                        📁 Browse
                                                                    </button>
                                                                    <input
                                                                        type="file"
                                                                        id="file-upload"
                                                                        ref={fileInputRef}
                                                                        className="d-none"
                                                                        onChange={handleFileChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Show Upload/Cancel only after file is selected */}
                                                            {selectedFile && (
                                                                <div className="d-flex justify-content-end mt-3">
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm me-2"
                                                                        onClick={handleFormSubmit}
                                                                        disabled={!selectedFileName}
                                                                        title={!selectedFileName ? "Please select template" : "Upload selected file"}
                                                                    >
                                                                        Upload
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-secondary btn-sm"
                                                                        onClick={handleClearFile}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            )}

                                                        </>
                                                    )}
                                                </div>

                                                {/* Right Column */}
                                                <div className="col-md-8">

                                                    {formStructure?.details?.length > 0 ? (
                                                        <>
                                                            <div className={`mx-auto ${formStyles.customScrollForm}`} style={{ maxWidth: '600px' }}>
                                                                <form className="form" onSubmit={handleOCRSubmit}>
                                                                    {(() => {
                                                                        const processedFormData = preprocessFormData(formStructure.details, aiFormData);

                                                                        return formStructure.details
                                                                            .filter((detail) => detail.columnActive !== "N")
                                                                            .map((detail, index) => (
                                                                                <div className="form-group row mb-2" key={index}>
                                                                                    <label className="col-sm-4 col-form-label text-small label-black">
                                                                                        {detail.columnLabel
                                                                                            ?.replace(/_/g, ' ')
                                                                                            .toUpperCase()
                                                                                        }

                                                                                        {(detail.columnKey === "NOT NULL" || detail.columnKey === "PRIMARY KEY") && (
                                                                                            <span className="text-dark" style={{ marginLeft: '4px' }}>*</span>
                                                                                        )}
                                                                                    </label>
                                                                                    <div className="col-sm-7">
                                                                                        {detail.columnName === 'Remaining_Amount' ? (
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                name={detail.columnName}
                                                                                                value={processedFormData[detail.columnName] || ''}
                                                                                                readOnly
                                                                                            />
                                                                                        ) : (
                                                                                            renderInput(
                                                                                                detail,
                                                                                                processedFormData[detail.columnName],
                                                                                                (val) => handleInputChange(detail.columnName, val)
                                                                                            )
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ));
                                                                    })()}
                                                                </form>
                                                            </div>

                                                            {/* ✅ Buttons moved outside the form */}
                                                            <div className="form-group row mb-2 mt-1">
                                                                <div className="w-100 d-flex justify-content-center">
                                                                    <input
                                                                        type="button"
                                                                        className="btn btn-secondary btn-sm me-3"
                                                                        value="Reset"
                                                                        onClick={handleFormReset}
                                                                    />
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={handleOCRSubmit}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="text-center mt-4 text-muted">
                                                            <strong>Choose Department and Template.</strong>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}


                                        <Modal show={modalMessage}
                                            //  onHide={() => setModalMessage('')}
                                            backdrop="static" keyboard={false}
                                            style={{ marginTop: '12vh' }}>
                                            <div
                                                className={`alert alert-${messageType === 'success'
                                                    ? 'success'
                                                    : messageType === 'warning'
                                                        ? 'warning'
                                                        : 'danger'
                                                    } alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2 mx-2" style={{ color: 'green' }}>✅</span>
                                                    ) : messageType === 'error' ? (
                                                        <span className="me-2" style={{ color: 'red' }}>❌</span>
                                                    ) : null}

                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            fontSize: '14px',
                                                            color: messageType === 'success' ? 'green' :
                                                                (messageType === 'warning' ? 'black' : 'red'),
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: modalMessage }} >
                                                    </p>
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleModalClose} // Single function to handle both success and error cases
                                                    style={{
                                                        width: '15px',
                                                        height: '12px',
                                                        fontSize: '8px',
                                                        position: 'absolute',
                                                        bottom: '10px',
                                                        right: '10px',
                                                    }}
                                                ></button>
                                            </div>
                                        </Modal>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
            <Footer />
        </div >
    );

}

export default GapsyTablelist;
